import i18next, { i18n as i18nType, Module } from 'i18next';
import i18nextXHRBackend from 'i18next-http-backend';
import ICU from 'i18next-icu';

import en from './translations/en.json';
import kk from './translations/kk.json';
import pl from './translations/pl.json';
import ru from './translations/ru.json';
import uz from './translations/uz.json';
import uzCyrl from './translations/uz-cyrl.json';

// const combineURLs = (baseURL: string, relativeURL: string): string =>
// 	relativeURL ? `${baseURL.replace(/\/+$/, ``)}/${relativeURL.replace(/^\/+/, ``)}` : baseURL;

const icu = new ICU({
	memoize: true,
	memoizeFallback: false,
});

export const getNewI18n = (language: string): i18nType => {
	const i18n = i18next.createInstance();

	void i18n
		.use(icu as unknown as Module)
		.use(i18nextXHRBackend)
		.init({
			lng: language,
			fallbackLng: `en`,
			debug: import.meta.env.DEV, // process.env.NODE_ENV === 'development',
			// defaultNS: defaultNamespace,
			// ns: namespaces,
			keySeparator: false,
			interpolation: {
				escapeValue: false,
				formatSeparator: `,`,
			},
			resources: {
				ru,
				en,
				kk,
				pl,
				uz,
				'uz-Cyrl-UZ': uzCyrl,
			},
		});

	return i18n;
};
